import {useDispatch} from "react-redux";
import {ReactComponent as ArrowLeft} from "assets/image/Layout/Common/ic_panel_arrow_left.svg";
import {ReactComponent as Play} from "assets/image/Layout/Header/ic_play.svg";
import {ReactComponent as Stop} from "assets/image/Layout/Header/ic_stop.svg";
import PublishPopup from "components/PopUp/PublishPopup";
import {showPopUp} from "components/PopUp";
import {changeMode} from "store/actions/mode";
import {MODE_TYPE} from "utils";
import {useIntl} from "react-intl";
import CustomTooltip from "components/Common/Tooltip/CustomTooltip";
import styles from "./index.module.scss";

export default function Develop({isPropertyPanelOpen, handlePropertyPanel, isEditMode}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const onChangeMode = () => {
    dispatch(changeMode(isEditMode ? MODE_TYPE.PLAY_MODE : MODE_TYPE.EDIT_MODE));
    const btn = document.getElementById("change_mode_btn");
    btn.blur();
  };

  const onClickPublish = () => {
    showPopUp(<PublishPopup />, {
      defaultPadding: false,
      transparentBackground: true,
    });
  };

  return (
    <div className={styles.menu}>
      <button className={styles.publish} type="button" onClick={onClickPublish}>
        Publish
      </button>
      <CustomTooltip
        description={
          isEditMode ? intl.formatMessage({id: "ID_STUDIO_TOOLTIP_PLAY_BTN"}) : intl.formatMessage({id: "ID_STUDIO_TOOLTIP_STOP_BTN"})
        }
        placement={"bottomLeft"}
      >
        <button type="button" id="change_mode_btn" onClick={onChangeMode} className={styles.run_btn}>
          {isEditMode ? <Play /> : <Stop />}
        </button>
      </CustomTooltip>

      <button
        type="button"
        onClick={handlePropertyPanel}
        className={`${isPropertyPanelOpen || !isEditMode ? styles.panel_hide : ""} ${styles.panel_btn}`}
      >
        <CustomTooltip description={intl.formatMessage({id: "ID_STUDIO_TOOLTIP_PROPERTY_PANEL_OPEN"})} placement={"bottomRight"}>
          <ArrowLeft />
        </CustomTooltip>
      </button>
    </div>
  );
}
